import React, { useState, useEffect, useRef } from "react";
import {
    Image
} from "react-bootstrap";
import { translate } from "react-multi-lang";
import { connect } from "react-redux";
import api from "../../Environment";
import { createNotification } from "react-redux-notify";
import configuration from "react-global-configuration";
import {
    fetchSingleStreamStart,
    saveLiveStreamUsersStart,
    leaveLiveStreamUserStart,
} from "../../store/actions/PostAction";
import AgoraVideoCall from "../../components/LiveStream/AgoraVideoCall";
import { fetchSingleUserStreamProfileStart } from "../../store/actions/OtherUserAction";
import io from "socket.io-client";
import {
    fetchStreamChatUsersStart,
    addStreamMessageContent,
    deleteStreamChatStart
} from "../../store/actions/Livestream";
import { getErrorNotificationMessage } from "../helper/NotificationMessage";
import { SocketState } from '../Socket/SocketProvider'
import SendTipModal from "../helper/SendTipModal";
import "./LiveStream.css";

const LiveStreamDemo = (props) => {

    const { userDetails, livestream, streamMessages } = props;
    const [messages, setMessages] = useState([]);
    const [inputMessage, setInputMessage] = useState("");
    const [viewerCount, setViewerCount] = useState(0);
    const [initialHeight, setInitialHeight] = useState(0);
    const messagesRef = useRef(null);
    const [config, setConfig] = useState(null);
    const streamTitle = livestream.data.title || "";
    const { liveStreamSocket, liveStreamSocketUrl, setLiveStreamSocket, setLiveStreamSocketUrl } = SocketState()
    const [sendTip, setSendTip] = useState(false);
    const [exitTrigger, setExitTrigger] = useState(null);
    const [callEndText, setCallEndText] = useState("");
    const [showInfo, setShowInfo] = useState(false);

    // if private stream host can see link and copy it
    const [copied, setCopied] = useState(false);
    const link = `${window.location.origin}/liveStream/${props.match.params.stream_id}`;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Copy failed");
        }
    };

    // on page load check livechat socket url get or not. if not get set
    useEffect(() => {
        if (liveStreamSocketUrl == "")
            setLiveStreamSocketUrl(configuration.get("configData.livestream_socket_url"));
        // setLiveStreamSocketUrl("http://localhost:3014");

        props.dispatch(
            fetchSingleStreamStart({
                stream_id: props.match.params.stream_id,
            })
        );
    }, []);

    // get liveStreamSocketUrl and connect to chat socket for livestream
    useEffect(() => {
        // console.log("liveStreamSocketUrl", liveStreamSocketUrl)
        // console.log("liveStreamSocket", liveStreamSocket)
        if (liveStreamSocketUrl && !liveStreamSocket) {
            console.log("user connect 2")
            setLiveStreamSocket(
                io(liveStreamSocketUrl, {
                    query:
                        `commonid:'user_id_` +
                        localStorage.getItem("userId") +
                        `',myid:` +
                        localStorage.getItem("userId"),
                })
            );
        }

        // if (!liveStreamSocketUrl) {
        //     const notificationMessage = getErrorNotificationMessage(
        //         "Socket URL is not configured. Chat will not work..."
        //     );
        //     props.dispatch(createNotification(notificationMessage));
        // }
    }, [liveStreamSocketUrl]);


    useEffect(() => {
        if (localStorage.getItem("userId") != livestream.data.host_id && livestream.data.host_unique_id) {
            props.dispatch(
                fetchSingleUserStreamProfileStart({
                    user_unique_id: livestream.data.host_unique_id,
                })
            );
        }

        if (!livestream.loading) {
            setConfig({
                mode: livestream.data.mode,
                codec: livestream.data.codec,
                appId: livestream.data.appId,
                token: livestream.data.token,
                channel: livestream.data.channel,
                transcode: livestream.data.transcode,
                videoProfile: livestream.data.videoProfile,
                baseMode: livestream.data.baseMode,
                uid: livestream.data.user_id,
                unique_id: livestream.data.unique_id,
            })

            // props.dispatch(
            //   saveLiveStreamUsersStart({
            //     live_stream_id: livestream.data.stream_id,
            //     user_id: ids,
            //   })
            // );
        }
    }, [livestream.loading]);

    useEffect(() => {
        props.dispatch(
            fetchStreamChatUsersStart({ stream_id: props.match.params.stream_id })
        );

        if (messagesRef.current) {
            messagesRef.current.scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "nearest",
            });
        }
    }, [props.match.params.stream_id]);

    useEffect(() => {
        if (
            streamMessages.data.messages &&
            streamMessages.data.messages.length
        ) {
            // console.log("streamMessages", streamMessages.data.messages)
            setMessages(streamMessages.data.messages);
        }
    }, [streamMessages.data.messages]);

    // Scroll down function..
    useEffect(() => {
        const objDiv = document.getElementById("options-holder");

        if (objDiv != null) {
            let differenceNumber =
                objDiv.offsetHeight > objDiv.scrollHeight
                    ? objDiv.offsetHeight - objDiv.scrollHeight
                    : objDiv.scrollHeight - objDiv.offsetHeight;

            if (differenceNumber > 280) {
                objDiv.scrollTop = objDiv.scrollHeight;
            } else {
                objDiv.scrollTop = initialHeight;
                setInitialHeight(initialHeight + 20);
            }
        }
    }, [streamMessages.data.messages]);


    //  const chatInputChange = (value) => {
    //     setInputMessage(value);
    //   }

    let handleUserUpdate = (id, event) => {
        // props.dispatch(
        //   GetLiveStreamUsers({ live_stream_id: livestream.data.stream_id })
        // );

        props.dispatch(
            saveLiveStreamUsersStart({
                live_stream_id: livestream.data.stream_id,
                user_id: id,
            })
        );

        // if (liveStreamSocketUrl === "") {
        //   console.log("no keys configured");
        // } else {
        //   //socket start

        //   // if (liveStreamSocketUrl) {
        //   //   liveStreamSocket = io(liveStreamSocketUrl, {
        //   //     query:
        //   //       `commonid:'user_id_` +
        //   //       localStorage.getItem("userId") +
        //   //       `_to_user_id_` +
        //   //       "" +
        //   //       `',myid:` +
        //   //       localStorage.getItem("userId"),
        //   //   });
        //   if (liveStreamSocket) {
        //     liveStreamSocket.emit("video-call-join", {
        //       host_id: livestream.data.host_id,
        //       user_id: livestream.data.user_id,
        //       stream_id: livestream.data.stream_id,
        //     });

        //     liveStreamSocket.on("livestream_user_count", (newData) => {
        //       //console.log("newData", newData);
        //       setViewerCount(newData);
        //     });

        //   }
        // }
    };


    let handleUserJoin = async (id, event) => {

        // await props.dispatch(
        //   saveLiveStreamUsersStart({
        //     live_stream_id: livestream.data.stream_id,
        //     user_id: id,
        //   })
        // );

        if (liveStreamSocketUrl === "") {
            console.log("no keys configured");
        } else {
            //socket start
            if (liveStreamSocket && Object.keys(liveStreamSocket).length != 0) {

                await liveStreamSocket.emit("video-call-join", {
                    host_id: livestream.data.host_id,
                    user_id: livestream.data.user_id,
                    stream_id: livestream.data.stream_id,
                });

                await liveStreamSocket.on("livestream_user_count", (newData) => {
                    // console.log("livestream_user_count", newData);
                    newData = newData < 0 ? 0 : newData;
                    setViewerCount(newData);
                });

            }
        }
    };


    let handleUserLeave = (id, event) => {
        props.dispatch(
            leaveLiveStreamUserStart({
                live_stream_id: livestream.data.stream_id,
                user_id: id,
            })
        );

        // if (livestream.data.host_id == Number(id)) {
        //   console.log(livestream.data.host_id, id);
        //   props.dispatch(
        //     deleteStreamChatStart({
        //       stream_id: livestream.data.stream_id
        //     })
        //   );
        // }

        if (liveStreamSocketUrl === "") {
            console.log("no keys configured");
        } else {
            //socket start

            // if (liveStreamSocketUrl) {
            //   liveStreamSocket = io(liveStreamSocketUrl, {
            //     query:
            //       `commonid:'user_id_` +
            //       localStorage.getItem("userId") +
            //       `_to_user_id_` +
            //       "" +
            //       `',myid:` +
            //       localStorage.getItem("userId"),
            //   });
            if (liveStreamSocket && Object.keys(liveStreamSocket).length != 0) {
                liveStreamSocket.emit("video-call-exit", {
                    host_id: livestream.data.host_id,
                    user_id: livestream.data.user_id,
                    stream_id: livestream.data.stream_id,
                });

                liveStreamSocket.on("livestream_user_count", (newData) => {
                    // console.log("newData", newData);
                    newData = newData < 0 ? 0 : newData;
                    setViewerCount(newData);
                });

            }
            else {
                // liveStreamSocket.disconnect();
            }

            // }
            //socket end
        }
    };

    // auto scroll chat
    useEffect(() => {
        if (messagesRef.current) {
            messagesRef.current.scrollIntoView({
                behavior: "smooth",
            });
        }
    }, [messages.length]);

    const closeSendTipModal = () => {
        setSendTip(false);
    };


    const handleChatSubmit = async (event) => {
        event.preventDefault();

        if (liveStreamSocket && Object.keys(liveStreamSocket).length != 0 && inputMessage) {
            let chatData = [
                {
                    from_user_id: localStorage.getItem("userId"),
                    host_id: props.livestream.data.host_id,
                    user_id: localStorage.getItem("userId"),
                    stream_id: props.match.params.stream_id,
                    message: inputMessage,
                    type: "uu",
                    user_picture: localStorage.getItem("user_picture"),
                    loggedin_user_id: localStorage.getItem("userId"),
                    created: Date(),
                    from_username: localStorage.getItem("username"),
                    from_displayname: localStorage.getItem("name"),
                    from_userpicture: localStorage.getItem("user_picture"),
                    from_user_unique_id: "",
                    to_username: "",
                    to_displayname: "",
                    to_userpicture: "",
                    to_user_unique_id: "",
                },
            ];

            await liveStreamSocket.emit("send_message", chatData[0]);

            props.dispatch(addStreamMessageContent(chatData[0]));
            setInputMessage("");
        }
    };

    useEffect(() => {
        if (liveStreamSocket && Object.keys(liveStreamSocket).length != 0) {
            liveStreamSocket.on("receive_message", (newData) => {
                // setInputMessage("");

                // console.log("newData", newData);
                if (messages && messages.length) {
                    setMessages(...messages, newData);
                } else {
                    setMessages([newData]);
                }
                // console.log("-------", messages);
                props.dispatch(addStreamMessageContent(newData));
            });
        }
    }, [liveStreamSocket]);

    // click on handle exit go in child and call handle exit method
    const handleExit = async () => {

        setExitTrigger(true);
    }

    // click on handle exit go in child and call handle exit method
    const updateText = (text) => {
        // console.log("update text", text)
        setCallEndText(text)
    }

    useEffect(() => {
        const container = document.getElementById("options-holder");

        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    }, [messages]);

    return (
        <div className="live_container">

            {/* HEADER OVERLAY */}
            <div className="live-header">

                <div className="left-section">

                    <span className="stream-title">
                        {streamTitle}
                    </span>

                    <div className="info-container">

                        <span
                            className="info-icon"
                            onClick={() => setShowInfo(!showInfo)}
                        >
                            <i className="fa fa-info-circle" />
                        </span>

                        {showInfo && (
                            <div className="tooltip-box">
                                {livestream.data?.description}
                            </div>
                        )}

                    </div>

                    <span className="live-badge">
                        LIVE
                    </span>

                </div>

                <div className="overlay-right">

                    <span className="viewer-pill btn btn-info">
                        <i className="fa fa-users users-live mr-2"></i>
                        {viewerCount}
                    </span>

                    {livestream.data.stream_type == "Private" && livestream.data.host_id == Number(localStorage.getItem("userId")) &&
                        (<button
                            className="copy-link-btn btn btn-secondary"
                            onClick={handleCopy}
                        >
                            <i className="fa fa-link mr-2"></i>
                            {/* <span className="btn-text"> */}
                            {copied ? "Copied!" : "Copy Link"}
                            {/* </span> */}
                        </button>
                        )}
                    {localStorage.getItem("userId") != livestream.data.host_id && (
                        <button
                            className="tip-button btn btn-primary"
                            onClick={() => setSendTip(true)}
                        >
                            <i className="fa fa-dollar mr-2"></i>
                            Fund Me
                        </button>
                    )}

                    <button
                        className="exit-btn btn btn-danger"
                        onClick={handleExit}
                    >
                        <Image
                            src={window.location.origin + "/assets/images/icons/end_call.svg"}
                            className="mr-2"
                            style={{ filter: "invert(1)", width: "17px" }}
                        />
                        Exit
                    </button>

                </div>

            </div>
            {/* VIDEO SECTION */}
            <div className="video">



                {/* VIDEO PLAYER */}
                {livestream.loading ? (
                    <div className="live-spinner-wrapper">
                        <div className="live-spinner"></div>
                    </div>
                ) : (<AgoraVideoCall
                    videoProfile={livestream.data.videoProfile}
                    channel={livestream.data.channel}
                    transcode={livestream.data.transcode}
                    attendeeMode={livestream.data.mode}
                    baseMode={livestream.data.baseMode}
                    appId={livestream.data.appId}
                    uid={livestream.data.user_id}
                    host_id={livestream.data.host_id}
                    stream_id={livestream.data.stream_id}
                    codec={livestream.data.codec}
                    token={livestream.data.token}
                    host_user={userDetails && userDetails?.data?.user}
                    user_count={viewerCount}
                    user_update={handleUserUpdate}
                    user_join={handleUserJoin}
                    user_leave={handleUserLeave}
                    dispatch={props.dispatch}
                    exitTrigger={exitTrigger}
                    updateText={updateText}
                />

                )}

            </div>

            {/* CHAT SECTION */}
            <div className="chat">

                <div id="options-holder" className="messages"
                    onTouchStart={(e) => e.stopPropagation()}
                    onTouchMove={(e) => e.stopPropagation()}>

                    {messages.length <= 0 ? (
                        <div className="no-chat">
                            No messages yet.<br /> Start the conversation 💬
                        </div>
                    )
                        :
                        <>
                            {messages.map((msg, index) => (
                                <div
                                    key={index}
                                    className="message"
                                >
                                    {msg.from_user_id ==
                                        localStorage.getItem("userId") ?
                                        (<Image
                                            className="chat-image chat-image-default livestream-user-image mr-3"
                                            src={
                                                msg.from_userpicture && msg.from_userpicture != "null"
                                                    ? api.serviceUrl() +
                                                    "/" +
                                                    msg.from_userpicture
                                                    : "/assets/images/upload-profile-img.svg"
                                            }

                                        />) :
                                        (<Image
                                            className="chat-image chat-image-default livestream-user-image mr-3"
                                            src={
                                                msg.from_userpicture && msg.from_userpicture != "null"
                                                    ? api.serviceUrl() +
                                                    "/" +
                                                    msg.from_userpicture
                                                    : "/assets/images/upload-profile-img.svg"
                                            }
                                        />)}
                                    <strong>{msg.from_user_id ==
                                        localStorage.getItem("userId") ? "You" : msg.from_displayname} : </strong>
                                    {msg.message}
                                </div>

                            ))}
                        </>
                    }

                    <div ref={messagesRef}></div>

                </div>

                <form className="input-box">

                    <input
                        type="text"
                        name="send_message"
                        placeholder="Type a message..."
                        autoComplete={"off"}
                        value={inputMessage}
                        onChange={(e) =>
                            setInputMessage(e.target.value)
                        }
                    />

                    <button onClick={handleChatSubmit}>
                        Send
                    </button>

                </form>

            </div>

            {/* {localStorage.getItem("userId") != livestream.data.host_id && ( */}
            <SendTipModal
                sendTip={sendTip}
                closeSendTipModal={closeSendTipModal}
                username={userDetails?.data?.user?.username}
                userPicture={userDetails?.data?.user?.picture}
                name={
                    userDetails?.data?.user?.first_name.concat(
                        userDetails?.data?.user?.middle_name,
                        userDetails?.data?.user?.last_name
                    ) || userDetails?.data?.user?.username
                }
                post_id={null}
                user_id={livestream.data.host_id}
            />
            {/* )} */}

        </div>

    );
};

const mapStateToPros = (state) => ({
    livestream: state.post.livestream,
    userDetails: state.otherUser.userDetails,
    streamMessages: state.livestream.streamMessages,
});

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(translate(LiveStreamDemo));